import { render, staticRenderFns } from "./TracksEdit.vue?vue&type=template&id=48da0f5a"
import script from "./TracksEdit.vue?vue&type=script&lang=js"
export * from "./TracksEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports